/**
 * Section: Recently Searched Terms
 * -----------------------------------------------------------------------------
 * - A list with recently searched terms.
 */

(() => {
  const COOKIE_NAME = 'search_history';
  const MAX_TERMS = 10;
  const COOKIE_DAYS = 30;
  const CONTAINER_ID = 'recent-searches';

  const container = document.getElementById(CONTAINER_ID);
  const content = container?.querySelector('.recent-searches__content');

  const getSearchTerm = () =>
    new URLSearchParams(window.location.search).get('q')?.trim();

  const getCookie = (name) => {
    const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : null;
  };

  const setCookie = (name, value, days = COOKIE_DAYS) => {
    const expires = new Date(Date.now() + days * 86400000).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/`;
  };

  const updateSearchHistory = (term) => {
    if (!term) return;

    let terms = [];
    const raw = getCookie(COOKIE_NAME);

    if (raw) {
      try {
        terms = JSON.parse(raw);
      } catch (err) {
        console.warn('Invalid search history cookie format:', err);
      }
    }

    terms = [term, ...terms.filter((t) => t.toLowerCase() !== term.toLowerCase())].slice(0, MAX_TERMS);

    setCookie(COOKIE_NAME, JSON.stringify(terms));
  };

  const loadRecentSearches = () => {
    if (!container || !content) return;

    const raw = getCookie(COOKIE_NAME);
    let terms = [];

    if (raw) {
      try {
        terms = JSON.parse(raw);
      } catch (err) {
        console.warn('Invalid cookie format:', err);
      }
    }

    if (!Array.isArray(terms) || terms.length === 0) {
      container.classList.add('hidden');
      return;
    }

    container.classList.remove('hidden');
    content.innerHTML = createSearchList(terms.slice(0, 5));
  };

  const createSearchList = (terms) => {
    return `
      <ul class="recent-searches list-unstyled">
        ${terms
          .map(
            (term) =>
              `<li><a href="/search?q=${encodeURIComponent(term)}">${term}</a></li>`
          )
          .join('')}
      </ul>
    `;
  };

  document.addEventListener('DOMContentLoaded', () => {
    const currentPath = window.location.pathname;

    if (currentPath.includes('/search')) {
      const gridContainerElement = document.getElementById('ProductGridContainer');
      let hasSearchResults = false;

      if (gridContainerElement) {
        const searchResultsCount = parseInt(gridContainerElement.dataset.searchResultsCount, 10);
        hasSearchResults = !isNaN(searchResultsCount) && searchResultsCount > 0;
      }

      const term = getSearchTerm();

      if (term && hasSearchResults) {
        updateSearchHistory(term);
      }
    }

    loadRecentSearches();
  });
})();